import Pikachu from './Pikachu';
import image from './preview.png';

export const Image = image;
export default Pikachu;
